// const URL_SERVER = process.env.NODE_ENV === "development" ? "http://127.0.0.1:5000/api/" : "https://routing-frontend.n-vibe.com/api/";
const URL_SERVER =
  process.env.NODE_ENV === "development"
    ? "http://127.0.0.1:5000"
    : "https://streetnav-maps.n-vibe.com";

function urlServer(route) {
  return `${URL_SERVER}/api/calculator/${route}`;
  // return URL_SERVER + route;
}

export default urlServer;
